module.exports = __webpack_public_path__ + "img/nebula.e3c7414e.png";